module.exports = __webpack_public_path__ + "static/media/logo-correios-menu@2x.6da2af15.png";